/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_List_Filters_TitleInputs */



/**
* | output |
* | --- |
* | "Event List Filters" |
*
* @param {Event_List_Filters_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_list_filters_title = /** @type {((inputs?: Event_List_Filters_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_List_Filters_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Filtres de la liste d’événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Filter für die Ereignisliste")
	if (locale === "it") return /** @type {LocalizedString} */ ("Filtri elenco eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Фильтры списка событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Filtros de lista de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件列表筛选器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントリストフィルター")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट सूची फ़िल्टर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Filtros da lista de eventos")
	return /** @type {LocalizedString} */ ("Event List Filters")
});